import MessagesEmptyState from './MessagesEmptyState.component';

export default MessagesEmptyState;
